"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDpayPriceResponseToJSON = exports.GetDpayPriceResponseFromJSONTyped = exports.GetDpayPriceResponseFromJSON = void 0;
function GetDpayPriceResponseFromJSON(json) {
    return GetDpayPriceResponseFromJSONTyped(json, false);
}
exports.GetDpayPriceResponseFromJSON = GetDpayPriceResponseFromJSON;
function GetDpayPriceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dPayPricePerUsd': json['dPayPricePerUsd'],
    };
}
exports.GetDpayPriceResponseFromJSONTyped = GetDpayPriceResponseFromJSONTyped;
function GetDpayPriceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dPayPricePerUsd': value.dPayPricePerUsd,
    };
}
exports.GetDpayPriceResponseToJSON = GetDpayPriceResponseToJSON;
